import BackstageSettingsLayout from "./BackstageSettingsLayout"

export default BackstageSettingsLayout
